import React, { useLayoutEffect } from "react";

import SSEClass from "../components/sseprogram/sseprogram";
import Footer from "../components/footer/footer";
import SathyaSaiMenu from "../components/navbarmenu/navmenu";
import Banner from "../components/banner/banner";
import SSCMKESchedule from "../components/eventschedule/eventschedule";
import SSEFaqQ from "../components/ssefaq/ssefaq";
import BottomBanner from "../components/bottombanner/bottombanner";
import Menucardforallpage from "../components/menucardforallpage/menucardforallpage";
import QuoteBanner from "../components/quotebanner/quotebanner";

function SSE() {
  useLayoutEffect(() => {
      document.title = 'SSE - Sri Sathya Sai Center of Milwaukee | ssscmke.org';
  }, []);
  return (
    <div className="SSE">
        <SathyaSaiMenu />
        <Banner title="Sai Spiritual Education" pic="/images/sse-Banner.png"/>
        <QuoteBanner />
        <SSCMKESchedule />
        <SSEClass />
        <Menucardforallpage page="sse" />
        <SSEFaqQ />
        <BottomBanner />
        <Footer />
    </div>
  );
}
export default SSE;
